"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendIssuerCellToBtcBatchTransfer = exports.genBtcBatchTransferCkbVirtualTx = exports.genBtcTransferCkbVirtualTx = void 0;
const base_1 = require("@ckb-lumos/base");
const error_1 = require("../error");
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const signWitnesses_1 = __importDefault(require("@nervosnetwork/ckb-sdk-core/lib/signWitnesses"));
/**
 * Generate the virtual ckb transaction for the btc transfer tx
 * @param collector The collector that collects CKB live cells and transactions
 * @param xudtTypeBytes The serialized hex string of the XUDT type script
 * @param rgbppLockArgsList The rgbpp assets cell lock script args array whose data structure is: out_index | bitcoin_tx_id
 * @param transferAmount The XUDT amount to be transferred, if the noMergeOutputCells is true, the transferAmount will be ignored
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param noMergeOutputCells(Optional) The noMergeOutputCells indicates whether the CKB outputs need to be merged. By default, the outputs will be merged.
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const genBtcTransferCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, xudtTypeBytes, rgbppLockArgsList, transferAmount, isMainnet, noMergeOutputCells, witnessLockPlaceholderSize, ckbFeeRate, btcTestnetType, }) {
    var _b, e_1, _c, _d;
    const xudtType = base_1.blockchain.Script.unpack(xudtTypeBytes);
    if (!(0, utils_1.isUDTTypeSupported)(xudtType, isMainnet)) {
        throw new error_1.TypeAssetNotSupportedError('The type script asset is not supported now');
    }
    const deduplicatedLockArgsList = (0, utils_1.deduplicateList)(rgbppLockArgsList);
    const rgbppLocks = deduplicatedLockArgsList.map((args) => (0, rgbpp_1.genRgbppLockScript)(args, isMainnet, btcTestnetType));
    let rgbppTargetCells = [];
    let rgbppOtherTypeCells = [];
    try {
        for (var _e = true, rgbppLocks_1 = __asyncValues(rgbppLocks), rgbppLocks_1_1; rgbppLocks_1_1 = yield rgbppLocks_1.next(), _b = rgbppLocks_1_1.done, !_b; _e = true) {
            _d = rgbppLocks_1_1.value;
            _e = false;
            const rgbppLock = _d;
            const cells = yield collector.getCells({ lock: rgbppLock, isDataMustBeEmpty: false });
            (0, rgbpp_1.throwErrorWhenRgbppCellsInvalid)(cells, xudtTypeBytes, isMainnet);
            const targetCells = cells.filter((cell) => (0, utils_1.isScriptEqual)(cell.output.type, xudtTypeBytes));
            const otherTypeCells = cells.filter((cell) => !(0, utils_1.isScriptEqual)(cell.output.type, xudtTypeBytes));
            rgbppTargetCells = [...rgbppTargetCells, ...targetCells];
            rgbppOtherTypeCells = [...rgbppOtherTypeCells, ...otherTypeCells];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = rgbppLocks_1.return)) yield _c.call(rgbppLocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    rgbppTargetCells = rgbppTargetCells.sort(rgbpp_1.compareInputs);
    rgbppOtherTypeCells = rgbppOtherTypeCells.sort(rgbpp_1.compareInputs);
    let inputs = [];
    let sumInputsCapacity = BigInt(0);
    const outputs = [];
    const outputsData = [];
    let needPaymasterCell = false;
    // The non-target RGBPP outputs correspond to the RGBPP inputs one-to-one, and the outputs are still bound to the sender’s BTC UTXOs
    const handleNonTargetRgbppCells = (targetRgbppOutputLen) => {
        for (const [index, otherRgbppCell] of rgbppOtherTypeCells.entries()) {
            inputs.push({
                previousOutput: otherRgbppCell.outPoint,
                since: '0x0',
            });
            sumInputsCapacity += BigInt(otherRgbppCell.output.capacity);
            outputs.push(Object.assign(Object.assign({}, otherRgbppCell.output), { 
                // Vouts[targetRgbppOutputLen + 1], ..., Vouts[targetRgbppOutputLen + rgbppOtherTypeCells.length] for other RGBPP assets
                lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(targetRgbppOutputLen + index + 1), isMainnet, btcTestnetType) }));
            outputsData.push(otherRgbppCell.outputData);
        }
    };
    if (noMergeOutputCells) {
        // The target RGBPP outputs correspond to the RGBPP inputs one-to-one, and the outputs are bound to the receivers' BTC UTXOs
        for (const [index, targetRgbppCell] of rgbppTargetCells.entries()) {
            inputs.push({
                previousOutput: targetRgbppCell.outPoint,
                since: '0x0',
            });
            sumInputsCapacity += BigInt(targetRgbppCell.output.capacity);
            outputs.push(Object.assign(Object.assign({}, targetRgbppCell.output), { 
                // The Vouts[0] for OP_RETURN and Vouts[1], ..., Vouts[rgbppTargetCells.length] for target RGBPP assets
                lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(index + 1), isMainnet, btcTestnetType) }));
            outputsData.push(targetRgbppCell.outputData);
        }
        handleNonTargetRgbppCells(rgbppTargetCells.length);
    }
    else {
        // The target RGBPP assets are divided into two parts: transfer(bound to the receivers' BTC UTXO) and change(bound to the sender’s BTC UTXO).
        const collectResult = collector.collectUdtInputs({
            liveCells: rgbppTargetCells,
            needAmount: transferAmount,
        });
        inputs = collectResult.inputs;
        (0, rgbpp_1.throwErrorWhenTxInputsExceeded)(inputs.length);
        sumInputsCapacity = collectResult.sumInputsCapacity;
        const rgbppCellCapacity = (0, utils_1.calculateRgbppCellCapacity)(xudtType);
        const needRgbppChange = collectResult.sumAmount > transferAmount;
        // To simplify, when the xUDT does not need change, all the capacity of the inputs will be given to the receiver
        const receiverOutputCapacity = needRgbppChange ? BigInt(rgbppTargetCells[0].output.capacity) : sumInputsCapacity;
        // The Vouts[0] for OP_RETURN and Vouts[1] for target transfer RGBPP assets
        outputs.push({
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(1), isMainnet, btcTestnetType),
            type: xudtType,
            capacity: (0, utils_1.append0x)(receiverOutputCapacity.toString(16)),
        });
        outputsData.push((0, utils_1.append0x)((0, utils_1.u128ToLe)(transferAmount)));
        if (needRgbppChange) {
            const isCapacitySufficient = (0, rgbpp_1.isRgbppCapacitySufficientForChange)(sumInputsCapacity, receiverOutputCapacity);
            needPaymasterCell = !isCapacitySufficient;
            // When the capacity of inputs is enough for the outputs, the sender needs to recover the excess capacity.
            const udtChangeCapacity = isCapacitySufficient ? sumInputsCapacity - receiverOutputCapacity : rgbppCellCapacity;
            // The Vouts[2] for target change RGBPP assets
            outputs.push({
                lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(2), isMainnet, btcTestnetType),
                type: xudtType,
                capacity: (0, utils_1.append0x)(udtChangeCapacity.toString(16)),
            });
            outputsData.push((0, utils_1.append0x)((0, utils_1.u128ToLe)(collectResult.sumAmount - transferAmount)));
        }
        handleNonTargetRgbppCells(outputs.length);
    }
    const cellDeps = yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true, xudt: true }, btcTestnetType);
    if (needPaymasterCell) {
        cellDeps.push((0, constants_1.getSecp256k1CellDep)(isMainnet));
    }
    const witnesses = [];
    const lockArgsSet = new Set();
    const allRgbppCells = rgbppTargetCells.concat(rgbppOtherTypeCells);
    for (const cell of allRgbppCells) {
        if (lockArgsSet.has(cell.output.lock.args)) {
            witnesses.push('0x');
        }
        else {
            lockArgsSet.add(cell.output.lock.args);
            witnesses.push(constants_1.RGBPP_WITNESS_PLACEHOLDER);
        }
    }
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    if (!needPaymasterCell) {
        const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : (0, rgbpp_1.estimateWitnessSize)(deduplicatedLockArgsList));
        const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
        const changeCapacity = BigInt(outputs[outputs.length - 1].capacity) - estimatedTxFee;
        ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    }
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        needPaymasterCell,
        sumInputsCapacity: (0, utils_1.append0x)(sumInputsCapacity.toString(16)),
    };
});
exports.genBtcTransferCkbVirtualTx = genBtcTransferCkbVirtualTx;
/**
 * Generate the virtual ckb transaction for the btc batch transfer tx
 * @param collector The collector that collects CKB live cells and transactions
 * @param xudtTypeBytes The serialized hex string of the XUDT type script
 * @param rgbppLockArgsList The rgbpp assets cell lock script args array whose data structure is: out_index | bitcoin_tx_id
 * @param rgbppReceivers The rgbpp receiver list which include toBtcAddress and transferAmount
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const genBtcBatchTransferCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, xudtTypeBytes, rgbppLockArgsList, rgbppReceivers, isMainnet, btcTestnetType, }) {
    var _b, e_2, _c, _d;
    const xudtType = base_1.blockchain.Script.unpack(xudtTypeBytes);
    if (!(0, utils_1.isUDTTypeSupported)(xudtType, isMainnet)) {
        throw new error_1.TypeAssetNotSupportedError('The type script asset is not supported now');
    }
    const rgbppLocks = rgbppLockArgsList.map((args) => (0, rgbpp_1.genRgbppLockScript)(args, isMainnet, btcTestnetType));
    let rgbppCells = [];
    try {
        for (var _e = true, rgbppLocks_2 = __asyncValues(rgbppLocks), rgbppLocks_2_1; rgbppLocks_2_1 = yield rgbppLocks_2.next(), _b = rgbppLocks_2_1.done, !_b; _e = true) {
            _d = rgbppLocks_2_1.value;
            _e = false;
            const rgbppLock = _d;
            const cells = yield collector.getCells({ lock: rgbppLock, type: xudtType });
            if (!cells || cells.length === 0) {
                throw new error_1.NoRgbppLiveCellError('No rgbpp cells found with the xudt type script and the rgbpp lock args');
            }
            rgbppCells = [...rgbppCells, ...cells];
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = rgbppLocks_2.return)) yield _c.call(rgbppLocks_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    rgbppCells = rgbppCells.sort(rgbpp_1.compareInputs);
    const sumTransferAmount = rgbppReceivers
        .map((receiver) => receiver.transferAmount)
        .reduce((prev, current) => prev + current, BigInt(0));
    const rpbppCellCapacity = (0, utils_1.calculateRgbppCellCapacity)(xudtType);
    const outputs = rgbppReceivers.map((_, index) => ({
        // The Vouts[0] for OP_RETURN and Vouts[1], Vouts[2], ... for RGBPP assets
        lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(index + 1), isMainnet, btcTestnetType),
        type: xudtType,
        capacity: (0, utils_1.append0x)(rpbppCellCapacity.toString(16)),
    }));
    const outputsData = rgbppReceivers.map((receiver) => (0, utils_1.append0x)((0, utils_1.u128ToLe)(receiver.transferAmount)));
    const { inputs, sumInputsCapacity, sumAmount } = collector.collectUdtInputs({
        liveCells: rgbppCells,
        needAmount: sumTransferAmount,
    });
    (0, rgbpp_1.throwErrorWhenTxInputsExceeded)(inputs.length);
    // Rgbpp change cell index, if it is -1, it means there is no change rgbpp cell
    let rgbppChangeOutIndex = -1;
    if (sumAmount > sumTransferAmount) {
        // Rgbpp change cell is placed at the last position by default
        rgbppChangeOutIndex = rgbppReceivers.length + 1;
        outputs.push({
            // The Vouts[0] for OP_RETURN and Vouts[rgbppChangeOutIndex] for RGBPP change assets
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(rgbppChangeOutIndex), isMainnet, btcTestnetType),
            type: xudtType,
            capacity: (0, utils_1.append0x)(rpbppCellCapacity.toString(16)),
        });
        outputsData.push((0, utils_1.append0x)((0, utils_1.u128ToLe)(sumAmount - sumTransferAmount)));
    }
    const cellDeps = [
        ...(yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true, xudt: true }, btcTestnetType)),
        (0, constants_1.getSecp256k1CellDep)(isMainnet),
    ];
    const witnesses = [];
    const lockArgsSet = new Set();
    for (const cell of rgbppCells) {
        if (lockArgsSet.has(cell.output.lock.args)) {
            witnesses.push('0x');
        }
        else {
            lockArgsSet.add(cell.output.lock.args);
            witnesses.push(constants_1.RGBPP_WITNESS_PLACEHOLDER);
        }
    }
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        rgbppChangeOutIndex,
        needPaymasterCell: false,
        sumInputsCapacity: (0, utils_1.append0x)(sumInputsCapacity.toString(16)),
    };
});
exports.genBtcBatchTransferCkbVirtualTx = genBtcBatchTransferCkbVirtualTx;
/**
 * Append paymaster cell to the ckb transaction inputs and sign the transaction with paymaster cell's secp256k1 private key
 * @param secp256k1PrivateKey The Secp256k1 private key of the paymaster cells maintainer
 * @param issuerAddress The issuer ckb address
 * @param collector The collector that collects CKB live cells and transactions
 * @param ckbRawTx CKB raw transaction
 * @param sumInputsCapacity The sum capacity of ckb inputs which is to be used to calculate ckb tx fee
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet
 * @param ckbFeeRate The CKB transaction fee rate, default value is 1100
 */
const appendIssuerCellToBtcBatchTransfer = (_a) => __awaiter(void 0, [_a], void 0, function* ({ secp256k1PrivateKey, issuerAddress, collector, ckbRawTx, sumInputsCapacity, isMainnet, ckbFeeRate, }) {
    const rawTx = ckbRawTx;
    const rgbppInputsLength = rawTx.inputs.length;
    const sumOutputsCapacity = rawTx.outputs
        .map((output) => BigInt(output.capacity))
        .reduce((prev, current) => prev + current, BigInt(0));
    const issuerLock = (0, ckb_sdk_utils_1.addressToScript)(issuerAddress);
    let emptyCells = yield collector.getCells({ lock: issuerLock });
    if (!emptyCells || emptyCells.length === 0) {
        throw new error_1.NoLiveCellError('The issuer address has no empty cells');
    }
    emptyCells = emptyCells.filter((cell) => !cell.output.type);
    let actualInputsCapacity = BigInt(sumInputsCapacity);
    const txFee = constants_1.MAX_FEE;
    if (actualInputsCapacity <= sumOutputsCapacity) {
        const needCapacity = sumOutputsCapacity - actualInputsCapacity + constants_1.MIN_CAPACITY;
        const { inputs, sumInputsCapacity: sumEmptyCapacity } = collector.collectInputs(emptyCells, needCapacity, txFee);
        rawTx.inputs = [...rawTx.inputs, ...inputs];
        actualInputsCapacity += sumEmptyCapacity;
    }
    let changeCapacity = actualInputsCapacity - sumOutputsCapacity;
    const changeOutput = {
        lock: issuerLock,
        capacity: (0, utils_1.append0x)(changeCapacity.toString(16)),
    };
    rawTx.outputs = [...rawTx.outputs, changeOutput];
    rawTx.outputsData = [...rawTx.outputsData, '0x'];
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(rawTx) + constants_1.SECP256K1_WITNESS_LOCK_SIZE;
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    changeCapacity -= estimatedTxFee;
    rawTx.outputs[rawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    const keyMap = new Map();
    keyMap.set((0, ckb_sdk_utils_1.scriptToHash)(issuerLock), secp256k1PrivateKey);
    const issuerCellIndex = rgbppInputsLength;
    const cells = rawTx.inputs.map((input, index) => ({
        outPoint: input.previousOutput,
        lock: index >= issuerCellIndex ? issuerLock : (0, constants_1.getRgbppLockScript)(isMainnet),
    }));
    const emptyWitness = { lock: '', inputType: '', outputType: '' };
    const issuerWitnesses = rawTx.inputs.slice(rgbppInputsLength).map((_, index) => (index === 0 ? emptyWitness : '0x'));
    rawTx.witnesses = [...rawTx.witnesses, ...issuerWitnesses];
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(rawTx);
    const signedWitnesses = (0, signWitnesses_1.default)(keyMap)({
        transactionHash,
        witnesses: rawTx.witnesses,
        inputCells: cells,
        skipMissingKeys: true,
    });
    const signedTx = Object.assign(Object.assign({}, rawTx), { witnesses: signedWitnesses.map((witness) => typeof witness !== 'string' ? (0, ckb_sdk_utils_1.serializeWitnessArgs)(witness) : witness) });
    return signedTx;
});
exports.appendIssuerCellToBtcBatchTransfer = appendIssuerCellToBtcBatchTransfer;
